var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostCodeBarCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.94 32.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.98,
    height: 32.54
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.64,
    width: 6.51,
    height: 32.54
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.53,
    width: 2.74,
    height: 32.54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.92,
    width: 3.98,
    height: 32.54
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.56,
    width: 8.38,
    height: 32.54
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.96,
    width: 3.98,
    height: 32.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostCodeBarCode);
export default __webpack_public_path__ + "static/media/cost_code_bar_code.cdac1bcf13569618e53d8b44c4658ef1.svg";
export { ForwardRef as ReactComponent };